<template>
  <div class='dialog mi-common-broadcast' v-if="show">
    <div class="dialog-content-wrap">
      <div class="broadcast-dialog-content animated js-content" @click.stop >
        <div :class="'push-theme push-theme__' + type"></div>
        <div class="submit-btn" @click="closeDialog">我知道了</div>
        <div class="broadcast-content">
          <h5 class="title">{{title}}</h5>
          <div class="content-html-box" v-html="content"></div>
          <template v-if="images && images.length">
            <div class="carousel-box" v-if="images.length !== 1">
              <mi-swiper :autoplay="true" :duration="300" :interval="5000" :pagination="true">
                <template v-for="(img, index) in images" track-by="$index">
                  <mi-swiper-slide :key="img + '_' + index">
                    <a :href="img" target="_blank">
                      <img :src="img" alt=""/>
                    </a>
                  </mi-swiper-slide>
                </template>
              </mi-swiper>
            </div>
            <div class="carousel-box" v-else>
              <a :href="images[0]" target="_blank">
                <img :src="images[0]" alt=""/>
              </a>
            </div>
          </template>
          <div class="video-box" v-if="videos && videos.length">
            <div class="video-item" v-for="(index, video) in videos" :key="index" track-by="$index">
              <video controls :src="video"></video>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import MiSwiper from "common/mi-swiper/index.js";

  import cookies from 'common/cookie.js';

  export default {
    name: "common-broadcast",
    props: {
      id: Number,
      title: String,
      content: String,
      type: [String, Number],
      images: Array,
      videos: Array
    },
    components: {
      MiSwiper: MiSwiper.swiper,
      MiSwiperSlide: MiSwiper.slide
    },
    data() {
      return {
        show: true,
        userId: null,
        isSuperAdmin: false,
      };
    },
    methods: {
      closeDialog() {
        if (this.isSuperAdmin) { // 超级视角
          this.show = false;
          let key = '_broadcast__' + this.userId + '__' + this.id;
          let end = new Date(Date.now() + 3 * 24 * 3600 * 1000);
          cookies.setItem(key, 'hide', end);
        } else {
          this.$emit("close-broadcast", {
            id: this.id
          });
        }
      },
      init() {
        // 判断是否是超级视图
        this.isSuperAdmin = !!(cookies.getItem('adSaKey') || cookies.getItem('adSvKey'));
        this.userId = cookies.getItem('userId');
        if(this.isSuperAdmin) {
          let key = '_broadcast__' + this.userId + '__' + this.id;
          let val = cookies.getItem(key);
          this.show = !val;
        }
      },
    },
    created() {
      this.init();
    }
  };
</script>

<style lang="scss">
  .mi-common-broadcast {
    &.dialog {
      position: fixed;
      background: rgba(0,0,0,.7);
      z-index: 9999;
      overflow: auto;
      text-align: unset;
    }
    .dialog-content-wrap {
      .broadcast-dialog-content {
        position: relative;
        background: #FFF;
        b {
          font-weight: bold;
        }
        .broadcast-content {
          width: 748px;
          max-height: 560px;
          overflow-x: hidden;
          overflow-y: auto;
          border-radius: 16px;
          margin: 55px 30px 25px;
        }
        .submit-btn {
          width: 255px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          font-size: 14px;
          color: #FFF;
          z-index: 3333;
          position: absolute;
          bottom: -24px;
          left: 245px;
          background: #FF6701;
          border-radius:6px;
          cursor: pointer;
        }
        .push-theme {
          z-index: 3333;
          position: absolute;
          width: 440px;
          height: 103px;
          top: -56px;
          left: 132px;
          background: url('../assets/common-broadcast/type_1.png') no-repeat;
          &__1{
            width: 440px;
            height: 103px;
            top: -56px;
            left: 132px;
            background: url('../assets/common-broadcast/type_1.png') no-repeat;
          }
          &__2 {
            width: 452px;
            height: 114px;
            top: -61px;
            left: 120px;
            background: url('../assets/common-broadcast/type_2.png') no-repeat;
          }
          &__3 {
            width: 140px;
            height: 109px;
            top: -28px;
            left: unset;
            right: 24px;
            background: url('../assets/common-broadcast/type_3.png') no-repeat;
          }
        }
        .title {
          padding: 0;
          background-color: #FFF;
          color: #666;
          font-size: 22px;
          line-height: 24px;
          font-family: MicrosoftYaHei;
          text-align: center;
          margin-bottom: 21px;
        }
        .content-html-box {
          line-height: 24px;
          margin-bottom: 6px;
          table {
            border: 1px solid #ebeef5;
            td, th {
              border: 1px solid #ebeef5;
              padding: 5px 10px;
            }
            th {
              background: #f5f5f5;
            }
          }
        }
        .carousel-box {
          width: 620px;
          margin: 0 auto 15px;
          padding:0;
          .mi-swiper-slide {
            flex-shrink: 0;
            img {
              width: 620px;
            }
          }
        }
        .video-box {
          width: 620px;
          margin-left: auto;
          margin-right: auto;
          .video-item {
            width: 100%;
            margin-bottom: 15px;
            video {
              width: 100%;
            }
          }
        }
      }
    }
  }
</style>